/* Turbo Parts — vehicle-aware search SUGGESTIONS.
 * The predictive-search popup only keyword-matches titles, so a vehicle query like
 * "428i" showed "No results found" even though the fitment collection has 150+ parts —
 * scaring buyers off before they press Enter (where tp-search-route.js would land them
 * on the right collection). This script watches the popup: when the typed query is a
 * known vehicle (tp-search-map.json), it swaps the no-results message for a branded
 * "We've got parts for X" banner with real product cards pulled from that collection,
 * plus a "See all" link. Non-vehicle queries are left completely native.
 */
(function () {
  var map = null, mapLoading = false;
  var cardCache = {};
  var BANNER_ID = 'tp-suggest-banner';

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  // Tolerant vehicle match — same rules as tp-search-route.js. Strips trailing filler
  // words ("ford falcon ba parts" -> "ford falcon ba") but never hijacks a real part
  // query ("falcon brake pads" stays a search, handled by garage scoping instead).
  var FILLER = { parts: 1, part: 1, spares: 1, spare: 1, accessories: 1, accessory: 1,
                 for: 1, my: 1, the: 1, a: 1, genuine: 1, aftermarket: 1, oem: 1, new: 1 };
  function matchVehicle(q) {
    if (!map || !q) return null;
    if (map[q]) return map[q];
    var words = q.split(' ');
    while (words.length > 1 && FILLER[words[0]]) words.shift();   // drop leading filler
    if (map[words.join(' ')]) return map[words.join(' ')];
    for (var n = words.length; n >= 1; n--) {
      var pref = words.slice(0, n).join(' ');
      if (!map[pref]) continue;
      if (words.slice(n).every(function (w) { return FILLER[w]; })) return map[pref];
    }
    return null;
  }

  function loadMap() {
    if (map || mapLoading || !window.tpSearchMapUrl) return;
    mapLoading = true;
    fetch(window.tpSearchMapUrl)
      .then(function (r) { return r.json(); })
      .then(function (d) { map = (d && d.map) || {}; refresh(); })
      .catch(function () { mapLoading = false; });
  }

  function ensureStyle() {
    if (document.getElementById('tp-suggest-style')) return;
    var st = document.createElement('style');
    st.id = 'tp-suggest-style';
    st.textContent =
      '#' + BANNER_ID + '{padding:14px 16px 16px;}' +
      '#' + BANNER_ID + ' .tp-sg__head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;}' +
      '#' + BANNER_ID + ' .tp-sg__title{font-size:13.5px;font-weight:700;color:#17263F;}' +
      '#' + BANNER_ID + ' .tp-sg__title small{display:block;font-weight:600;color:rgba(23,38,63,.6);font-size:11.5px;margin-top:2px;}' +
      '#' + BANNER_ID + ' .tp-sg__all{flex-shrink:0;background:#CF3B2D;color:#FBF6E9;border-radius:999px;padding:8px 14px;font-size:12px;font-weight:700;text-decoration:none;white-space:nowrap;}' +
      '#' + BANNER_ID + ' .tp-sg__all:hover{background:#17263F;}' +
      '#' + BANNER_ID + ' .tp-sg__row{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;}' +
      '@media (max-width:600px){#' + BANNER_ID + ' .tp-sg__row{grid-template-columns:repeat(2,1fr);}}' +
      '#' + BANNER_ID + ' .tp-sg__card{background:#fff;border:1px solid #E0D6BF;border-radius:10px;padding:7px;text-decoration:none;display:block;}' +
      '#' + BANNER_ID + ' .tp-sg__card:hover{border-color:#17263F;}' +
      '#' + BANNER_ID + ' .tp-sg__img{width:100%;aspect-ratio:1;object-fit:contain;border-radius:6px;background:#fff;display:block;}' +
      '#' + BANNER_ID + ' .tp-sg__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:11px;font-weight:600;color:#17263F;line-height:1.3;min-height:2.6em;margin:6px 0 3px;}' +
      '#' + BANNER_ID + ' .tp-sg__price{font-size:11.5px;font-weight:800;color:#17263F;}';
    document.head.appendChild(st);
  }

  function fetchCards(tag, label, cb) {
    if (cardCache[tag]) { cb(cardCache[tag]); return; }
    fetch('/collections/all/' + tag)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = [];
        var els = doc.querySelectorAll('product-card');
        for (var i = 0; i < els.length && cards.length < 4; i++) {
          var el = els[i];
          var link = el.querySelector('.product-card__link');
          if (!link) continue;
          var title = (link.textContent || '').trim();
          var img = el.querySelector('img[src], img[data-src]');
          var priceEl = el.querySelector('[class*="price"]');
          var price = '';
          if (priceEl) {
            var m = (priceEl.textContent || '').match(/\$[\d,]+(?:\.\d{2})?/);
            if (m) price = m[0];
          }
          if (title && img) {
            cards.push({href: link.getAttribute('href'), title: title, img: img.getAttribute('src') || img.getAttribute('data-src'), price: price});
          }
        }
        cardCache[tag] = cards;
        cb(cards);
      })
      .catch(function () { cb([]); });
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  // Same display-only title swap the collection page does (tp-fit-title.js): these are
  // multi-fit parts whose titles name a donor car ("BMW 1 E81 Bracket…") — show them
  // as the car the customer actually searched ("BMW 428i Bracket…").
  var BOUNDARY = new RegExp('\\b(' + [
    'Front', 'Rear', 'Left', 'Right', 'LH', 'RH', 'Upper', 'Lower', 'Inner', 'Outer',
    'Bushing', 'Bush', 'Mounting', 'Mount', 'Shock', 'Strut', 'Control', 'Sway',
    'Stabiliser', 'Stabilizer', 'Link', 'Ball', 'Tie', 'Rod', 'Boot', 'CV', 'Drive',
    'Shaft', 'Oil', 'Seal', 'Gasket', 'Filter', 'Pump', 'Radiator', 'Hose', 'Belt',
    'Tensioner', 'Idler', 'Alternator', 'Starter', 'Sensor', 'Coil', 'Plug', 'Injector',
    'Headlight', 'Taillight', 'Tailgate', 'Fog', 'Lamp', 'Light', 'Mirror', 'Door',
    'Window', 'Regulator', 'Handle', 'Lock', 'Bumper', 'Grille', 'Guard', 'Fender',
    'Bonnet', 'Wiper', 'Washer', 'Brake', 'Pad', 'Rotor', 'Disc', 'Caliper', 'Wheel',
    'Hub', 'Bearing', 'Axle', 'Spring', 'Clutch', 'Flywheel', 'Engine', 'Exhaust',
    'Muffler', 'Thermostat', 'Fan', 'Compressor', 'Condenser', 'Cabin', 'Air', 'Fuel',
    'Ignition', 'Battery', 'Spark', 'Crossmember', 'Arm', 'Bar', 'End', 'Kit', 'Set',
    'O-Ring', 'Ring', 'Joint', 'Nut', 'Bolt', 'Screw', 'Clip', 'Grommet', 'Cap',
    'Valve', 'Relay', 'Switch', 'Solenoid', 'Bracket', 'Trim', 'Moulding',
    'Weatherstrip', 'Pipe', 'Gaiter', 'Cover', 'Sump', 'Differential', 'Gearbox',
    'Transmission', 'Steering', 'Suspension', 'Tripod', 'Crankshaft', 'Camshaft',
    'Pulley', 'Flange', 'Yoke', 'Knuckle', 'Booster', 'Reservoir', 'Overflow',
    'Expansion', 'Actuator', 'Blower', 'Resistor', 'Motor', 'Tank'
  ].join('|') + ')\\b');

  var VEH_KEYWORD = /^(series|class|lci|gen|mk\d*|i{1,3}|hb|sedan|wagon|ute|hatch|coupe|van)$/i;
  function vehicleishToken(tok, idx) {
    // every slash-joined part must look vehicle-ish (F22/F23, VT/VX…)
    return tok.split('/').every(function (p) {
      if (!p) return true;
      if (idx <= 1 && /^[A-Za-z][A-Za-z.&-]*$/.test(p)) return true;   // make/model word up front
      if (/^\d{1,4}[a-z]{0,3}$/i.test(p)) return true;                 // 1, 200, 428i
      if (/^[a-z]{1,3}\d{1,4}[a-z]{0,2}$/i.test(p)) return true;       // E81, F30, VT, KUN26R
      return VEH_KEYWORD.test(p);
    });
  }

  function swapTitle(label, title) {
    if (!title || !label || label.indexOf(' ') < 0) return title;   // need make + model/badge
    var variant = label.split(' ').slice(1).join(' ');
    if (title.toLowerCase().indexOf(variant.toLowerCase()) >= 0) return title; // already right
    // walk the leading vehicle tokens; cut where the part description starts
    var cut = -1, pos = 0;
    var toks = title.split(/\s+/);
    for (var i = 0; i < toks.length; i++) {
      var tok = toks[i].replace(/[,]+$/, '');
      var isBoundary = BOUNDARY.test(tok);
      BOUNDARY.lastIndex = 0;
      if (isBoundary || !vehicleishToken(tok, i)) { cut = pos; break; }
      pos += toks[i].length + 1;
    }
    if (cut < 3) return title;                       // no vehicle prefix to replace
    return label + ' ' + title.slice(cut);
  }

  function currentQuery() {
    var inp = document.querySelector('predictive-search-component input.search-input');
    return inp ? norm(inp.value) : '';
  }

  var lastKey = '';
  function refresh() {
    var inner = document.querySelector('.predictive-search-results__inner');
    var dropdown = document.querySelector('.predictive-search-dropdown');
    var host = inner || dropdown;
    if (!host) { lastKey = ''; return; }
    var q = currentQuery();
    var hit = matchVehicle(q);
    var existing = document.getElementById(BANNER_ID);
    var noRes = host.querySelector('.predictive-search-results__no-results');

    if (!hit) {
      if (existing) existing.remove();
      if (noRes) noRes.style.removeProperty('display');
      lastKey = '';
      return;
    }
    if (noRes) noRes.style.display = 'none';
    var key = q + '|' + hit.c;
    if (existing && lastKey === key) return;
    if (existing) existing.remove();
    lastKey = key;
    ensureStyle();

    var url = '/collections/all/' + hit.c + '?fit=' + encodeURIComponent(hit.l);
    var box = document.createElement('div');
    box.id = BANNER_ID;
    box.innerHTML =
      '<div class="tp-sg__head">' +
        '<span class="tp-sg__title">We&rsquo;ve got parts for ' + esc(hit.l) + '<small>Press Enter or tap to browse everything that fits</small></span>' +
        '<a class="tp-sg__all" href="' + url + '">See all parts &rarr;</a>' +
      '</div>' +
      '<div class="tp-sg__row" data-tp-cards></div>';
    host.insertBefore(box, host.firstChild);

    fetchCards(hit.c, hit.l, function (cards) {
      var row = box.querySelector('[data-tp-cards]');
      if (!row || currentQuery() !== q) return;
      row.innerHTML = cards.map(function (c) {
        return '<a class="tp-sg__card" href="' + esc(c.href) + '" title="' + esc(c.title) + '">' +
          '<img class="tp-sg__img" src="' + esc(c.img) + '" alt="" loading="lazy">' +
          '<span class="tp-sg__name">' + esc(swapTitle(hit.l, c.title)) + '</span>' +
          (c.price ? '<span class="tp-sg__price">' + esc(c.price) + '</span>' : '') +
        '</a>';
      }).join('');
    });
  }

  var t = null;
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('predictive-search-component')) return;
    loadMap();
    clearTimeout(t);
    t = setTimeout(refresh, 180);
  }, true);

  // Instant Enter: use the FULL live value (no debounce race) and, for a recognised
  // vehicle, jump straight to its fitment collection instead of round-tripping through
  // /search. Non-vehicle queries keep the theme's native submit untouched.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    var inp = e.target;
    if (!inp || !inp.closest || !inp.closest('predictive-search-component')) return;
    if (inp.tagName !== 'INPUT') return;
    var hit = matchVehicle(norm(inp.value));
    if (!hit) return;                       // let the normal search submit proceed
    e.preventDefault();
    e.stopPropagation();
    window.location.assign('/collections/all/' + hit.c + '?fit=' + encodeURIComponent(hit.l));
  }, true);
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('predictive-search-component')) loadMap();
  }, true);

  // The theme re-renders the dropdown async after its own fetch — re-apply on changes.
  var mo = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(refresh, 120);
  });
  function arm() {
    var comp = document.querySelector('predictive-search-component');
    if (comp) mo.observe(comp, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
